(function ($) {

  $(document).ready(() => {

    if ($(".google-reviews-carousel").length !== 0) {
      var slider_google = tns({
        "container": ".google-reviews-carousel",
        "speed": 400,
        "gutter": 0,
        "navPosition": "bottom",
        "responsive": {
          "1200": {
            "disable": false,
            "fixedWidth": 450,
            "nav" : false,
            /*"items": 3,*/
            "mouseDrag": true
          }
        }
      });
    }

  })
})(jQuery);
